import {
  Avatar,
  Button,
  Col,
  DatePicker,
  Flex,
  Form,
  Input,
  InputNumber,
  Modal,
  Row,
  Select,
  TimePicker,
  Typography,
} from "antd";

import React, { useEffect } from "react";
import { CustomTitle } from "../../../../../common/customTitle";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import RequiredLabel from "../../../../../common/required-label/RequiredLabel";
import { useTranslation } from "react-i18next";
import {
  dateObjToDispViewDate,
  sanitizeDataTypeClientSide,
  timeObjToDispViewTimeWithSuffix,
} from "../../../../../../utils/utils";
import {
  getCustomerDetailsAction,
  getServiceProviderCustomersAction,
  searchCustomersAction,
} from "../../../../../../redux/services/service-provider-customers/serviceProviderCustomersServices";
import { appConstConfig } from "../../../../../../constants/config/appConstConfig";
import Actions from "../../../../../../redux/actions";
import useDebounce from "../../../../../../hooks/useDebounce";
import { appAssetsConfig } from "../../../../../../constants/config/appAssetsConfig";
import { colors } from "../../../../../../constants/colors";
import {
  getStaffAction,
  getStaffSelectListAction,
} from "../../../../../../redux/services/staff/staffServices";
import { getServicesSelectList } from "../../../../../../redux/services/services/servicesApis";
import { getServicesSelectListAction } from "../../../../../../redux/services/services/servicesServices";
import dayjs from "dayjs";
import { checkServiceAvailabilityAction, checkStaffAvailabilityAction, createServiceProviderAppointmentAction } from "../../../../../../redux/services/service-provider-appointments/serviceProviderAppointmentsServices";
import { UserOutlined } from "@ant-design/icons";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.tz.guess()

const BookAppointmentDialog = ({ open, onClose }) => {
  /* i18n dependencies */
  const { t } = useTranslation();
  /* i18n dependencies */

  /* For navigating between pages */
  const navigate = useNavigate();
  /* For navigating between pages */

  /* dispatch an action */
  const dispatch = useDispatch();
  /* dispatch an action */

  /* login details */
  const { loginDetails } = useSelector((state) => state.auth);
  /* login details */

  /* form dependencies */
  const [form] = Form.useForm();
  const bookingFor = Form.useWatch("booking_for", { form, preserve: true });
  const orderType = Form.useWatch("order_type", { form, preserve: true });
  const initialValues = {
    appointment_date: null,
    appointment_time: "",
  };
  const [pagination, setPagination] = useState({
    pageNo: appConstConfig.DEFAULT_TABLE_PAGE_NUMBER,
    pageSize: 500,
  });
  /* form dependencies */

  /* loading dependencies */
  const [loading, setLoading] = useState(false);
  const [selectListLoader, setSelectListLoader] = useState(false);
  const [staffList, setStaffList] = useState([]);
  /* loading dependencies */

  /* id dependencies */
  let timeout = null;
  const { selectedAppointmentDate } = useSelector(
    (state) => state.serviceProviderAppointments
  );

  const { selectedServiceProviderCustomerDetails } = useSelector(
    (state) => state.serviceProviderCustomers
  );
  /* id dependencies */

  /* select list dependencies */
  const [
    serviceProviderCustomersSelectList,
    setServiceProviderCustomersSelectList,
  ] = useState([]);
  const [
    selectedServiceProviderCustomerObj,
    setSelectedServiceProviderCustomerObj,
  ] = useState(null);
  const [selectedServiceObj, setSelectedServiceObj] = useState(null);
  const [selectedServiceProviderObj, setSelectedServiceProviderObj] =
    useState(null);
  const [selectedOrder, setSelectedOrder] = useState("");
  const { staffSelectList } = useSelector((state) => state.staff);
  const { servicesSelectList, serviceSelectListBasedOnAvailability, staffSelectListBasedOnAvailability } = useSelector((state) => state.services);
  /* select list dependencies */

  /* initial dependencies */
  useEffect(() => {
    form.setFieldsValue({
      appointment_date: selectedAppointmentDate?.appointmentDate || null,
      appointment_time: selectedAppointmentDate?.appointmentTime || "",
    });
  }, [selectedAppointmentDate]);
  /* initial dependencies */

  const selectListApiCalls = async () => {
    const dataToBeSentForStaffSelectList = { page: 1, limit: 500 };
    // service provider / staff select list
    dispatch(
      getStaffSelectListAction(dataToBeSentForStaffSelectList, setLoading)
    );

    // services select list
    const dataToBeSentForServicesSelectList = { page: 1, limit: 500 };
    dispatch(
      getServicesSelectListAction(dataToBeSentForServicesSelectList, setLoading)
    );
  };

  useEffect(() => {
    selectListApiCalls();
  }, []);

  /* on customer search */
  const onCustomerSearch = (searchValue) => {
    let searchVal = searchValue.trim();
    if (
      searchVal &&
      searchVal !== "" &&
      searchVal !== undefined &&
      searchVal !== null
    ) {
      if (timeout) {
        clearTimeout(timeout);
        timeout = null;
      }

      const searchCustomers = () => {
        const dataToBeSent = {
          page: pagination?.pageNo,
          limit: pagination?.pageSize,
          search: searchValue,
        };

        dispatch(searchCustomersAction(dataToBeSent, setLoading)).then(
          (apiRes) => {
            const customers = apiRes?.data;
            setServiceProviderCustomersSelectList(
              customers?.map((element) => ({
                ...element,
                value: element?._id,
                label: `${element?.first_name} ${element?.last_name}`,
              }))
            );
          }
        );
      };

      if (searchValue) {
        timeout = setTimeout(searchCustomers, 500);
      } else {
        setServiceProviderCustomersSelectList([]);
      }
    }
  };
  /* on customer search */

  /* on customer changed */
  const onCustomerChanged = (value) => {
    const selectedServiceProviderCustomerObject =
      serviceProviderCustomersSelectList?.find((item) => item._id === value);
    setSelectedServiceProviderCustomerObj(
      selectedServiceProviderCustomerObject
    );

    if (value && value !== undefined && value !== "") {
      const dataToBeSent = {
        selectedServiceProviderCustomerId: value,
      };
      dispatch(getCustomerDetailsAction(dataToBeSent, setLoading)).then(
        (apiRes) => {
          const response = apiRes;
        }
      );
    }
  };
  /* on customer changed */

  /* function definition for getting service provider availability */
  const getServiceProviderAvailbility = (category) => {
    const dataToBeSentForStaffAvailability = {
      appointment_date : dayjs(selectedAppointmentDate?.appointmentDate).format("YYYY-MM-DD"),
      appointment_time : dayjs(selectedAppointmentDate?.appointmentTime).format("HH:mm:ss"),
      category_id : category
    }
    dispatch(checkStaffAvailabilityAction(dataToBeSentForStaffAvailability, setLoading))
  }
  /* function definition for getting service provider availability */

  /* function definition for getting service availability */
  const getServiceAvailability = () => {
    const dataToBeSentForServiceAvailability = {
      appointment_date : dayjs(selectedAppointmentDate?.appointmentDate).format("YYYY-MM-DD"),
      appointment_time : dayjs(selectedAppointmentDate?.appointmentTime).format("HH:mm:ss")
    }
    dispatch(checkServiceAvailabilityAction(dataToBeSentForServiceAvailability, setLoading))
  }
  /* function definition for getting service availability */

  /* on order changed */
  const onOrderTypeChanged = (value) => {
    form.setFieldValue("total_amount", 0);
    form.setFieldValue("service_id", null);
    form.setFieldValue("service_provider_id", null);
    if (value && value !== undefined && value !== "") {
      switch (value) {
        case "service_provider":
          selectListApiCalls();
          getServiceProviderAvailbility()
          break;

        case "service":
          dispatch(Actions.createAction(Actions.GET_STAFF_SELECT_LIST_BASED_ON_AVAILABILITY,{staffSelectListBasedOnAvailability:[]}))
          getServiceAvailability()
          break;

        default:
          break;
      }
    }
    setSelectedOrder(value);
  };
  /* on order changed */

  /* on service changed */
  const onServiceChanged = async (value) => {
    const selectedServiceObject = serviceSelectListBasedOnAvailability?.find(
      (element) => element._id === value
    );

    setSelectedServiceObj(selectedServiceObject);
    getChargesBasedOnServiceAndServiceProvider(selectedServiceObject);
    form.setFieldValue("service_provider_id", null);

    getServiceProviderAvailbility(selectedServiceObject?.categoryInfo?.category || "");
  };
  /* on service changed */

  /* on service provider changed */
  const onServiceProviderChanged = (value) => {
    const selectedServiceProviderObject = staffSelectListBasedOnAvailability?.find(
      (element) => element._id === value
    );
    setSelectedServiceProviderObj(selectedServiceProviderObject);
    if (selectedOrder === "service_provider")
      getChargesBasedOnServiceAndServiceProvider(selectedServiceProviderObject);
  };
  /* on service provider changed */

  /* charges calculation dependencies */
  const getChargesBasedOnServiceAndServiceProvider = (selectedObj) => {
    let tempCharges = 0;
    switch (selectedOrder) {
      case "service":
        tempCharges = selectedObj?.price;
        form.setFieldValue("total_amount", tempCharges);
        break;

      case "service_provider":
        tempCharges = selectedObj?.fees;
        form.setFieldValue("total_amount", tempCharges);
        break;

      default:
        break;
    }
  };
  /* charges calculation dependencies */

  const onRelationshipChanged = (value) => {
    const selectedRelationshipObj =
      selectedServiceProviderCustomerDetails?.relationships?.find(
        (element) => element?.relationship === value
      );
    form.setFieldValue("first_name", selectedRelationshipObj?.first_name || "");
    form.setFieldValue("last_name", selectedRelationshipObj?.last_name || "");
  };

  /* dialog close dependencies */
  const handleDialogClose = () => {
    form.resetFields();
    onClose();
    setServiceProviderCustomersSelectList([]);
    setSelectedServiceProviderCustomerObj(null);
  };
  /* dialog close dependencies */

  /* on submit */
  const onSubmit = (values) => {
    const {
      first_name,
      last_name,
      relationship,
      appointment_date,
      appointment_time,
      ...rest
    } = values;
    const dataToBeSent = {
      ...rest,
    };

    if (values?.booking_for === "other")
      dataToBeSent["booking_for_details"] = {
        first_name,
        last_name,
        relationship,
      };
    if (values?.booking_for === "self")
      dataToBeSent["booking_for_details"] = {
        first_name: selectedServiceProviderCustomerObj?.first_name,
        last_name: selectedServiceProviderCustomerObj?.last_name,
        email: selectedServiceProviderCustomerObj?.email,
      };
    dataToBeSent["appointment_date"] =
      dayjs(appointment_date).format("YYYY-MM-DD") || "";
    dataToBeSent["appointment_time"] =
      dayjs(appointment_time).format("HH:mm:ssZ") || "";
    dataToBeSent["tax_amount"] = 0;
    dataToBeSent["subtotal_amount"] = rest?.total_amount;
    dataToBeSent["national_id_number"] = selectedServiceProviderCustomerObj?.national_id_number || "";

    dispatch(
      createServiceProviderAppointmentAction(dataToBeSent, navigate, setLoading)
    ).then(() => {
      handleDialogClose();
    });
  };
  /* on submit */

  const appointmentType = [{ value: "IN_PERSON", label: "In Person" }];

  // loginDetails?.organization_id?.current_plan_id?.code === "Elite" &&
  loginDetails?.organization_id?.current_plan_id?.code === "ELITE-PREMIUM" &&
    appointmentType.push({ value: "VIDEO_CALL", label: "Video Call" });

  return (
    <Modal
      open={open}
      onCancel={handleDialogClose}
      footer={false}
      confirmLoading={loading}
      width={800}
    >
      <Flex vertical gap="3rem" align="center" justify="center">
        <CustomTitle textDecoration="underline" justifyContent="center">
        {t("Modules.Appointments.bookSlot")}
        </CustomTitle>
      </Flex>
      <Form
        style={{ marginTop: 20 }}
        form={form}
        layout="vertical"
        autoComplete="off"
        requiredMark={false}
        onFinish={onSubmit}
        initialValues={initialValues}
      >
        <Row gutter={[16, 16]}>
          <Col span={12}>
            <Form.Item
              name="user_id"
              label={
                <RequiredLabel
                  text={t("Modules.Appointments.customerUserName")}
                  required={true}
                />
              }
              rules={[
                {
                  required: true,
                  message: t("Modules.Appointments.pleaseSelectCustomerUserName"),
                },
                {
                  whitespace: true,
                  message: t("Modules.Appointments.pleaseSelectCustomerUserName"),
                },
              ]}
              normalize={(value) => sanitizeDataTypeClientSide(value)}
            >
              <Select
                showSearch
                loading={selectListLoader}
                placeholder={t("Modules.Appointments.searchByCustomerUserName")}
                notFoundContent={null}
                filterOption={false}
                defaultActiveFirstOption={false}
                onSearch={onCustomerSearch}
                onChange={onCustomerChanged}
                allowClear
                onClear={() => setServiceProviderCustomersSelectList([])}
              >
                {serviceProviderCustomersSelectList &&
                  serviceProviderCustomersSelectList?.map((item) => (
                    <Select.Option key={item?.value} value={item?.value}>
                      <Row gutter={[24, 24]} align="middle">
                        <Col span={3}>
                          <Avatar
                            size="default"
                            src={item?.profile_image}
                            icon={<UserOutlined />}
                          />
                        </Col>
                        <Col span={21}>
                          <Flex vertical>
                              <Typography.Title
                                  level={5}
                                  style={{ color: colors.electricBlue }}
                                >
                                  {`${item?.label} - ${item?.username}` || "-"}
                                </Typography.Title>
                            <Typography.Title level={5} style={{ margin: 0 }}>
                              {item?.email}
                            </Typography.Title>
                          </Flex>
                        </Col>
                      </Row>
                    </Select.Option>
                  ))}
              </Select>
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item
              name="booking_for"
              label={
                <RequiredLabel
                  text={t("Modules.Appointments.bookingFor")}
                  required={true}
                />
              }
              rules={[
                {
                  required: true,
                  message: t("Modules.Appointments.pleaseSelectBookingFor"),
                },
              ]}
              normalize={(value) => sanitizeDataTypeClientSide(value)}
            >
              <Select
                showSearch
                loading={selectListLoader}
                options={[
                  { value: "self", label: "Self" },
                  { value: "other", label: "Other" },
                ]}
                placeholder={t("Modules.Appointments.selectBookingFor")}
                onChange={() => {
                  form.setFieldValue("relationship", null);
                  form.setFieldValue("first_name", null);
                  form.setFieldValue("last_name", null);
                }}
              />
            </Form.Item>
          </Col>

          {bookingFor === "other" ? (
            <>
              <Col span={12}>
                <Form.Item
                  name="relationship"
                  label={
                    <RequiredLabel
                      text={t("Modules.Appointments.relationship")}
                      required={true}
                    />
                  }
                  rules={[
                    {
                      required: true,
                      message: t(
                        "Modules.Appointments.pleaseSelectRelationship"
                      ),
                    },
                  ]}
                >
                  <Select
                    showSearch
                    loading={selectListLoader}
                    options={[
                      { value: "father", label: "Father" },
                      { value: "mother", label: "Mother" },
                      { value: "husband", label: "Husband" },
                      { value: "wife", label: "Wife" },
                      { value: "son", label: "Son" },
                      { value: "daughter", label: "Daughter" },
                      { value: "brother", label: "Brother" },
                      { value: "sister", label: "Sister" },
                      { value: "grandfather", label: "Grandfather" },
                      { value: "grandmother", label: "Grandmother" },
                      { value: "uncle", label: "Uncle" },
                      { value: "aunty", label: "Aunty" },
                      { value: "other", label: "Other" },
                    ]}
                    placeholder={t("Modules.Appointments.selectRelationship")}
                    onChange={onRelationshipChanged}
                  />
                </Form.Item>
              </Col>

              <Col span={12}>
                <Form.Item
                  label={
                    <RequiredLabel
                      text={t("Modules.Staff.StaffForm.firstName")}
                      required={true}
                    />
                  }
                  name="first_name"
                  rules={[
                    {
                      required: true,
                      message: t(
                        "Modules.Staff.StaffForm.pleaseEnterFirstName"
                      ),
                    },
                    {
                      whitespace: true,
                      message: t(
                        "Modules.Staff.StaffForm.pleaseEnterFirstName"
                      ),
                    },
                  ]}
                  normalize={(value) => sanitizeDataTypeClientSide(value)}
                >
                  <Input
                    placeholder={t("Modules.Staff.StaffForm.enterFirstName")}
                  />
                </Form.Item>
              </Col>

              <Col span={12}>
                <Form.Item
                  label={
                    <RequiredLabel
                      text={t("Modules.Staff.StaffForm.lastName")}
                      required={true}
                    />
                  }
                  name="last_name"
                  rules={[
                    {
                      required: true,
                      message: t("Modules.Staff.StaffForm.pleaseEnterLastName"),
                    },
                    {
                      whitespace: true,
                      message: t("Modules.Staff.StaffForm.pleaseEnterLastName"),
                    },
                  ]}
                  normalize={(value) => sanitizeDataTypeClientSide(value)}
                >
                  <Input
                    placeholder={t("Modules.Staff.StaffForm.enterLastName")}
                  />
                </Form.Item>
              </Col>
            </>
          ) : (
            <></>
          )}

          <Col span={12}>
            <Form.Item
              name="order_type"
              label={
                <RequiredLabel
                  text={t("Modules.Appointments.orderType")}
                  required={true}
                />
              }
              rules={[
                {
                  required: true,
                  message: t("Modules.Appointments.pleaseSelectOrderType"),
                },
              ]}
            >
              <Select
                showSearch
                loading={selectListLoader}
                options={[
                  { value: "service", label: "Service" },
                  { value: "service_provider", label: "Service Provider" },
                ]}
                placeholder={t("Modules.Appointments.selectOrderType")}
                onChange={onOrderTypeChanged}
              />
            </Form.Item>
          </Col>
          {orderType === "service" && (
            <Col span={12}>
              <Form.Item
                name="service_id"
                label={
                  <RequiredLabel
                    text={t("Modules.Appointments.service")}
                    required={true}
                  />
                }
                rules={[
                  orderType === "service" && {
                    required: true,
                    message: t("Modules.Appointments.pleaseSelectService"),
                  },
                ]}
              >
                <Select
                  showSearch
                  loading={selectListLoader}
                  options={serviceSelectListBasedOnAvailability}
                  placeholder={t("Modules.Appointments.selectService")}
                  onChange={onServiceChanged}
                  filterOption={(input, option) =>
                    (option?.label ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                />
              </Form.Item>
            </Col>
          )}
          {(orderType === "service" || orderType === "service_provider") && (
            <Col span={12}>
              <Form.Item
                name="service_provider_id"
                label={
                  <RequiredLabel
                    text={orderType === "service" ? t("Modules.Appointments.staffName") : t("Modules.Appointments.doctorName")}
                    required={true}
                  />
                }
                rules={[
                  {
                    required:
                      orderType === "service" ||
                      orderType === "service_provider"
                        ? true
                        : false,
                    message: orderType === "service" ? t("Modules.Appointments.pleaseSelectStaffName") : t("Modules.Appointments.pleaseSelectDoctorName"),
                  },
                ]}
              >
                <Select
                  showSearch
                  loading={selectListLoader}
                  options={staffSelectListBasedOnAvailability}
                  placeholder={orderType === "service" ? t("Modules.Appointments.selectStaffName") : t("Modules.Appointments.selectDoctorName")}
                  onChange={onServiceProviderChanged}
                  filterOption={(input, option) =>
                    (option?.label ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                />
              </Form.Item>
            </Col>
          )}

          <Col span={12}>
            <Form.Item
              label={
                <RequiredLabel
                  text={t("Modules.Appointments.appointmentTime") + " (UAE)"}
                  required={true}
                />
              }
              name="appointment_time"
              rules={[
                {
                  required: true,
                  message: t(
                    "Modules.Appointments.pleaseSelectAppointmentTime"
                  ),
                },
              ]}
            >
              <TimePicker
                style={{ width: "100%", cursor: "pointer" }}
                use12Hours
                format="h:mm a"
                onKeyDown={(event) => event.preventDefault()}
                disabled
              />
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item
              label={
                <RequiredLabel
                  text={t("Modules.Appointments.appointmentDate")}
                  required={true}
                />
              }
              name="appointment_date"
              rules={[
                {
                  required: true,
                  message: t(
                    "Modules.Appointments.pleaseSelectAppointmentDate"
                  ),
                },
              ]}
            >
              <DatePicker
                style={{ width: "100%", cursor: "pointer" }}
                placeholder={t("Modules.Appointments.selectAppointmentDate")}
                onKeyDown={(event) => event.preventDefault()}
                disabled
                format={"DD-MM-YYYY"}
              />
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item
              name="appointment_mode"
              label={
                <RequiredLabel
                  text={t("Modules.Appointments.appointmentMode")}
                  required={true}
                />
              }
              rules={[
                {
                  required: true,
                  message: t(
                    "Modules.Appointments.pleaseSelectAppointmentMode"
                  ),
                },
              ]}
            >
              <Select
                showSearch
                loading={selectListLoader}
                options={appointmentType}
                placeholder={t("Modules.Appointments.selectAppointmentMode")}
              />
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item
              label={
                <RequiredLabel
                  text={t("Modules.Appointments.charges")}
                  required={true}
                />
              }
              name="total_amount"
              rules={[
                {
                  required: true,
                  message: "",
                },
              ]}
            >
              <InputNumber
                style={{ width: "100%" }}
                type="number"
                controls={false}
                disabled
              />
            </Form.Item>
          </Col>

          <Col span={24}>
            <Flex gap="1rem" align="center" justify="center">
              <Button
                type="primary"
                htmlType="submit"
                loading={loading}
                disabled={loading}
              >
                {t("Modules.Appointments.BookAndConfirm")}
              </Button>

              {/* <Button
                type="dashed"
                htmlType="submit"
                loading={loading}
                disabled={loading}
              >
                {t("Modules.Appointments.SharePaymentLink")}
              </Button> */}
            </Flex>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default BookAppointmentDialog;
